export const RECEIVER_REJECTED_HEADERS = [
  {
    title: "User",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["user", "fullName"],
  },
  { title: "Amount", sortArrow: true, sortBy: "number", address: ["amount"] },
  { title: "Description" },
  { title: "Date", sortArrow: true, sortBy: "date", address: ["date"] },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Details" },
  { title: "Action" },
  { title: "Add Again" },
];
